// @flow
import jwtDecode from 'jwt-decode';
import { Cookies } from 'react-cookie';


/**
 * Checks if user is authenticated
 */
const isUserAuthenticated = () => {
    
    
    const user = getLoggedInUser();
    if (!user) {
        return false;
    }
    const decoded = jwtDecode(user.token);
    const currentTime = Date.now() / 1000;
    //console.log('decoded currentTime: ' +  currentTime);
    //console.log('decoded token: ' +  JSON.stringify(decoded));
    if (decoded.exp < currentTime || user.suspend) {
        console.warn('access token expired');
        //add test
        //const cookies = new Cookies();
        //cookies.set('user', null);

        return false;
    } else {
        return true;
    }
    
};

const getBadgeChat = () => {
    if(isUserAuthenticated()){
        const cookies = new Cookies();
        return cookies.get('badgeChat');
    }else{
        return '';
    }
}

const setBadgeChat = (badge) => {
    const cookies = new Cookies();
    cookies.set('badgeChat', (badge == '0' || badge == 0) ? '' : badge);
}

const getBadgeMaintenance = () => {
    if(isUserAuthenticated()){
        const cookies = new Cookies();
        return cookies.get('badgeMaintenance');
    }else{
        return '';
    }
}

const setBadgeMaintenance = (badge) => {
    const cookies = new Cookies();
    cookies.set('badgeMaintenance', (badge == '0' || badge == 0) ? '' : badge);
}

/**
 * Returns the logged in user
 */
const getLoggedInUser = () => {
    /*
    user: {"id":1,"username":"test","firstName":"Test","lastName":"User","role":"Admin","token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJDb2RlcnRoZW1lIiwiaWF0IjoxNTU1NjgyNTc1LCJleHAiOjE1ODcyMTg1NzUsImF1ZCI6ImNvZGVydGhlbWVzLmNvbSIsInN1YiI6InRlc3QiLCJmaXJzdG5hbWUiOiJIeXBlciIsImxhc3RuYW1lIjoiVGVzdCIsIkVtYWlsIjoidGVzdEBoeXBlci5jb2RlcnRoZW1lcy5jb20iLCJSb2xlIjoiQWRtaW4ifQ.8qHJDbs5nw4FBTr3F8Xc1NJYOMSJmGnRma7pji0YwB4"}
    */
    const cookies = new Cookies();
    //set cookie --> work here
    //cookies.set('user', {"id":1,"username":"test","firstName":"Test","lastName":"User","role":"Admin","token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJDb2RlcnRoZW1lIiwiaWF0IjoxNjA4OTc5MjE4LjU0NSwiZXhwIjoxNjA4OTg5MjE4LjU0NSwiYXVkIjoiY29kZXJ0aGVtZXMuY29tIiwic3ViIjoidGVzdCIsImZpcnN0bmFtZSI6Ikh5cGVyIiwibGFzdG5hbWUiOiJUZXN0IiwiRW1haWwiOiJ0ZXN0QGh5cGVyLmNvZGVydGhlbWVzLmNvbSIsIlJvbGUiOiJBZG1pbiJ9.4fv2iPuiDx8bEP_G5NCzs0DTqFwuqtQKFG6Gv8EmtlI"});
    const user = cookies.get('user');
    // console.log('cookies user: ' +  JSON.stringify(user));
    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};

export { isUserAuthenticated, getLoggedInUser, setBadgeChat, getBadgeChat, setBadgeMaintenance, getBadgeMaintenance, };
